"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavIcon = void 0;
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Menu_1 = require("./Menu");
const NavIcon = () => {
    const context = React.useContext(Menu_1.MenuContext);
    const navIconOpen = context.menuState.modalVisible || context.menuState.searchVisible;
    const clickMenu = (e) => {
        e.preventDefault();
        if (!context.menuState.searchVisible) {
            context.setMenuState(Object.assign(Object.assign({}, context.menuState), { modalVisible: !context.menuState.modalVisible, searchVisible: false }));
        }
        if (!context.menuState.modalVisible && context.menuState.searchVisible) {
            context.setMenuState(Object.assign(Object.assign({}, context.menuState), { modalVisible: false, searchVisible: !context.menuState.searchVisible }));
        }
        if (context.menuState.modalVisible && context.menuState.searchVisible) {
            context.setMenuState(Object.assign(Object.assign({}, context.menuState), { modalVisible: false, searchVisible: false }));
        }
    };
    return (React.createElement(HamburgerWrapper, null,
        React.createElement(Hamburger, { onClick: clickMenu, className: navIconOpen ? 'open' : '' },
            React.createElement("span", null),
            React.createElement("span", null),
            React.createElement("span", null),
            React.createElement("span", null))));
};
exports.NavIcon = NavIcon;
const Hamburger = styled_components_1.default.a `
  display: block;
  width: 25px;
  height: 18px;
  position: absolute;
  margin: 0;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: 0.5s ease-in-out;
  -moz-transition: 0.5s ease-in-out;
  -o-transition: 0.5s ease-in-out;
  transition: 0.5s ease-in-out;
  cursor: pointer;

  span {
    display: block;
    position: absolute;
    height: 2px;
    width: 100%;
    background: #fff;
    opacity: 1;
    left: 0;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: 0.25s ease-in-out;
    -moz-transition: 0.25s ease-in-out;
    -o-transition: 0.25s ease-in-out;
    transition: 0.25s ease-in-out;
  }

  /* Icon 3 */

  span:nth-child(1) {
    top: 0px;
  }

  span:nth-child(2),
  span:nth-child(3) {
    top: 7px;
  }

  span:nth-child(4) {
    top: 14px;
  }

  &.open span:nth-child(1) {
    top: 14px;
    width: 0%;
    left: 50%;
  }

  &.open span:nth-child(2) {
    -webkit-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  &.open span:nth-child(3) {
    -webkit-transform: rotate(-45deg);
    -moz-transform: rotate(-45deg);
    -o-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }

  &.open span:nth-child(4) {
    top: 14px;
    width: 0%;
    left: 50%;
  }
`;
const HamburgerWrapper = styled_components_1.default.div `
  position: relative;
  width: 25px;
  height: 23px;
`;
//# sourceMappingURL=nav-icon.js.map